//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.CustomFeatureEvent.js";
let d=[[],[[["numBodies"],"GetBodies",{R_:{bodies:""}},0,0],[["bodies"],"SetBodies",{},1,0],[["parasolidId"],"CreateTrackingDataForParasolidEntity",{R_:{trackingData:"Features.TrackingData"}},1,1],[["nxObject"],"CreateTrackingDataForNXObject",{R_:{trackingData:"Features.TrackingData"}},1,1],[["trackingData"],"AppendOutputTrackingData",{},1,0],[["solidTag","parasolidBodyId","numSourceFaces","sourceFaces","parasolidFaceIds","numSourceEdges","sourceEdges","parasolidEdgeId"],"CopyNXBody",{},1,0],[["parasolidId"],"CreateTrackingDataForParasolidEntity1",{R_:{trackingData:"Features.TrackingData"}},1,0],[["nxObject"],"CreateTrackingDataForNXObject1",{R_:{trackingData:"Features.TrackingData"}},1,0]],[]];
SPLM.Features.CustomFeatureCreateFeatureGeometryEvent = class extends SPLM.Features.CustomFeatureEvent{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CustomFeatureCreateFeatureGeometryEvent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;